module.exports = __webpack_public_path__ + "static/media/movie-header-La-Casa.fa019609.png";